export const defaultTwitterCardMeta = 'summary_large_image';
export const blogUrlHeader =
	'https://blog.pilarhomes.com.br/?utm_source=sitePilarHomes&utm_medium=menu&utm_campaign=header&utm_content=origem-blog&utm_term=alwayson';
export const blogUrlFooter =
	' https://blog.pilarhomes.com.br/?utm_source=sitePilarHomes&utm_medium=menu&utm_campaign=footer&utm_content=origem-blog&utm_term=alwayson ';
